const LOGO_API_BASE = import.meta.env.VITE_LOGO_API_BASE || "https://img.logo.dev";
const LOGO_API_TOKEN = import.meta.env.VITE_LOGO_API_TOKEN || "";

function normalizeDomain(website: string): string {
  return website
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/.*$/, "");
}

export function companyLogoUrl(website: string | undefined, size: number): string | null {
  if (!website || !LOGO_API_TOKEN) return null;
  const domain = normalizeDomain(website);
  if (!domain) return null;
  return `${LOGO_API_BASE}/${domain}?token=${LOGO_API_TOKEN}&size=${size}&format=png`;
}
